import Vue from 'vue'
import moment from 'moment'
moment.updateLocale('ja', {
  weekdays: [
    '日曜日',
    '月曜日',
    '火曜日',
    '水曜日',
    '木曜日',
    '金曜日',
    '土曜日'
  ],
  weekdaysShort: ['日', '月', '火', '水', '木', '金', '土'],
  meridiem(hour, minute, isLowercase) {
    if (hour >= 0 && hour < 12) {
      return 'AM'
    } else {
      return 'PM'
    }
  }
})

// フィルタメソッド群を宣言

Vue.mixin({
  filters: {
    /**
     * 数値を3桁区切りにする
     *
     * @param {*} value
     * @returns
     */
    number_format(value) {
      return value.toLocaleString()
    },

    /**
     * 日付をフォーマットする
     *
     * @param {*} value
     * @param {string} [format='YYYY/MM/DD HH:mm']
     * @returns
     */
    date_format(value, format = 'YYYY/MM/DD HH:mm') {
      if (!value) return ''
      return moment(value).format(format)
    },

    /**
     * URL文字列をエンコードする
     *
     * @param {*} value
     * @returns
     */
    urlencode(value) {
      if (!value) return ''
      return encodeURIComponent(value)
    },

    /**
     * URL文字列をデコードする
     *
     * @param {*} value
     * @returns
     */
    urldecode(value) {
      if (!value) return ''
      return decodeURIComponent(value)
    },

    /**
     * 英字の先頭を大文字にする
     *
     * @param {*} value
     * @returns
     */
    capitalize(value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },

    /**
     * 英字をすべて大文字にする
     *
     * @param {*} value
     * @returns
     */
    uppercase(value) {
      if (!value) return ''
      value = value.toString()
      return value.toUpperCase()
    },

    /**
     * 英字をすべて小文字にする
     *
     * @param {*} value
     * @returns
     */
    lowercase(value) {
      if (!value) return ''
      value = value.toString()
      return value.toLowerCase()
    },

    /**
     * 円記号を付ける
     *
     * @param {*} value
     * @returns
     */
    yen(value) {
      if (!value) return ''
      value = value.toString()
      return '\u00A5' + value
    },

    /**
     * 引数の文字列を付ける
     * 1つのときは前、2つ以上のときは後に付ける
     * 引数の個数を超えると最後の値を付ける
     *
     * @param {*} value
     * @param {*} args
     * @returns
     */
    pluralize(value, ...args) {
      return args.length > 1
        ? value + (args[(value % 10) - 1] || args[args.length - 1])
        : args[0] + value
    },

    /**
     * jsonを文字列に変換する
     *
     * @param {*} value
     * @returns
     */
    json(value) {
      if (!value) return ''
      return JSON.stringify(value, null, 2)
    },

    /**
     * 配列の最大値を返す
     * 引数で2番目以降の最大値も指定できる
     *
     * @param {*} arr
     * @param {*} n リターンする最大値の数
     * @returns
     */
    max(arr, n) {
      if (!arr) return arr
      // リターンする最大値の数が下回る場合は、配列の数にする
      if (arr.length < n) {
        n = arr.length
      }
      if (n > 1) {
        const result = []
        while (result.length < n) {
          const max = Math.max(...arr)
          /* istanbul ignore next */
          if (~result.indexOf(max)) continue
          result.push(max)
          arr = arr.filter((v) => v !== max)
        }
        return result
      } else {
        return Math.max(...arr)
      }
    },

    /**
     * 配列の最小値を返す
     * 引数で2番目以降の最小値も指定できる
     *
     * @param {*} arr
     * @param {*} n リターンする最大値の数
     * @returns
     */
    min(arr, n) {
      if (!arr) return arr
      // リターンする最大値の数が下回る場合は、配列の数にする
      if (arr.length < n) {
        n = arr.length
      }
      if (n > 1) {
        const result = []
        while (result.length < n) {
          const min = Math.min(...arr)
          /* istanbul ignore next */
          if (~result.indexOf(min)) continue
          result.push(min)
          arr = arr.filter((v) => v !== min)
        }
        return result
      } else {
        return Math.min(...arr)
      }
    },

    /**
     * lengthを返す
     *
     * @param {*} arr
     * @returns
     */
    length(arr) {
      if (!arr) return arr
      return arr.length
    },

    /**
     * 配列内のどれかをランダムで返す
     * 引数で返す個数を指定できる
     *
     * @param {*} arr
     * @param {*} n リターンするランダム値の数
     * @returns
     */
    rand(arr, n) {
      if (!arr) return arr
      // リターンするランダム値の数を下回る場合は、配列の数にする
      if (arr.length < n) {
        n = arr.length
      }
      if (n > 1) {
        const result = []
        let index
        while (result.length < n) {
          index = Math.floor(Math.random() * arr.length)
          if (~result.indexOf(arr[index])) continue
          result.push(arr[index])
        }
        return result
      } else {
        return arr[Math.floor(Math.random() * arr.length)]
      }
    },

    /**
     * 配列の最初の値を返す
     *
     * @param {*} arr
     * @returns
     */
    first(arr) {
      if (!arr) return arr
      return arr[0]
    },

    /**
     * 配列の最後の値を返す
     *
     * @param {*} arr
     * @returns
     */
    last(arr) {
      if (!arr) return arr
      return arr[arr.length - 1]
    },

    /**
     * 文字列を逆にする
     *
     * @param {*} value
     * @returns
     */
    reverse(value) {
      if (!value) return ''
      return value
        .split('')
        .reverse()
        .join('')
    },

    /**
     * 指定した引数の文字数を超える文字列を省略する
     *
     * @param {*} value
     * @param {*} n
     * @param {*} o
     * @returns
     */
    truncate(value, n, o) {
      if (!value) return ''
      const len = n ? +n : 0
      const suffix = o ? o.toString() : '...'
      if (value.length <= len) return value
      return value.substring(0, len) + suffix
    },

    /**
     * 小数点切り捨て
     * 引数で小数点第何位で切り捨てるか指定できる
     *
     * @param {*} num
     * @param {*} n
     * @returns
     */
    trunc(num, n) {
      if (!num) return num
      const digit = String(num).split('.')[1]
        ? String(num).split('.')[1].length
        : null
      if (!digit) return num
      Math.trunc =
        Math.trunc ||
        /* istanbul ignore next */
        function(x) {
          return x < 0 ? Math.ceil(x) : Math.floor(x)
        }
      if (n > 1) {
        num *= 10 ** n
        return Math.trunc(num) / 10 ** n
      } else {
        return Math.trunc(num)
      }
    },

    /**
     * 数を固定小数点表記を用いて近似値で返す
     * 引数で小数点第何位か指定できる
     *
     * @param {*} num
     * @param {*} n
     * @returns
     */
    toFixed(num, n) {
      if (!num) return
      num = +num
      if (n > 1) {
        return num.toFixed(n)
      } else {
        return num.toFixed()
      }
    },

    /**
     * 全角カナまたは半角カナに変換して返す
     * 引数がないと半角カナ=>全角カナ
     * 引数が1だと全角カナ=>半角カナ
     *
     * @param {*} str
     * @param {*} n
     * @returns
     */
    kana(str, n) {
      if (!str) return str
      const inverseObject = function(obj, areKeysNumeric) {
        return Object.keys(obj).reduceRight(function(newMap, key) {
          /* istanbul ignore next */
          return (
            (newMap[obj[key]] = areKeysNumeric ? parseInt(key, 10) : key),
            newMap
          )
        }, {})
      }
      const henkanObj = {
        ア: '\uFF71',
        イ: '\uFF72',
        ウ: '\uFF73',
        エ: '\uFF74',
        オ: '\uFF75',
        カ: '\uFF76',
        キ: '\uFF77',
        ク: '\uFF78',
        ケ: '\uFF79',
        コ: '\uFF7A',
        サ: '\uFF7B',
        シ: '\uFF7C',
        ス: '\uFF7D',
        セ: '\uFF7E',
        ソ: '\uFF7F',
        タ: '\uFF80',
        チ: '\uFF81',
        ツ: '\uFF82',
        テ: '\uFF83',
        ト: '\uFF84',
        ナ: '\uFF85',
        ニ: '\uFF86',
        ヌ: '\uFF87',
        ネ: '\uFF88',
        ノ: '\uFF89',
        ハ: '\uFF8A',
        ヒ: '\uFF8B',
        フ: '\uFF8C',
        ヘ: '\uFF8D',
        ホ: '\uFF8E',
        マ: '\uFF8F',
        ミ: '\uFF90',
        ム: '\uFF91',
        メ: '\uFF92',
        モ: '\uFF93',
        ヤ: '\uFF94',
        ユ: '\uFF95',
        ヨ: '\uFF96',
        ラ: '\uFF97',
        リ: '\uFF98',
        ル: '\uFF99',
        レ: '\uFF9A',
        ロ: '\uFF9B',
        ワ: '\uFF9C',
        ヰ: '\uFF72', // 半角小文字の「ヰ」が変換できないため、「ｲ」半角文字のイを当てる
        ヱ: '\uFF74', // 半角小文字の「ヱ」が変換できないため、「ｴ」半角文字のエを当てる
        ヲ: '\uFF66',
        ン: '\uFF9D',
        ァ: '\uFF67',
        ィ: '\uFF68',
        ゥ: '\uFF69',
        ェ: '\uFF6A',
        ォ: '\uFF6B',
        ッ: '\uFF6F',
        ャ: '\uFF6C',
        ュ: '\uFF6D',
        ョ: '\uFF6E',
        ヵ: '\uFF76', // 半角小文字の「ヵ」が変換できないため、「ｶ」半角文字のカを当てる
        ヶ: '\uFF79', // 半角小文字の「ヶ」が変換できないため、「ｹ」半角文字のケを当てる
        ヮ: '\uFF9C', // 半角小文字の「ヮ」が変換できないため、「ﾜ」半角文字のワを当てる
        ガ: '\uFF76\uFF9E',
        ギ: '\uFF77\uFF9E',
        グ: '\uFF78\uFF9E',
        ゲ: '\uFF79\uFF9E',
        ゴ: '\uFF7A\uFF9E',
        ザ: '\uFF7B\uFF9E',
        ジ: '\uFF7C\uFF9E',
        ズ: '\uFF7D\uFF9E',
        ゼ: '\uFF7E\uFF9E',
        ゾ: '\uFF7F\uFF9E',
        ダ: '\uFF80\uFF9E',
        ヂ: '\uFF81\uFF9E',
        ヅ: '\uFF82\uFF9E',
        デ: '\uFF83\uFF9E',
        ド: '\uFF84\uFF9E',
        バ: '\uFF8A\uFF9E',
        ビ: '\uFF8B\uFF9E',
        ブ: '\uFF8C\uFF9E',
        ベ: '\uFF8D\uFF9E',
        ボ: '\uFF8E\uFF9E',
        パ: '\uFF8A\uFF9F',
        ピ: '\uFF8B\uFF9F',
        プ: '\uFF8C\uFF9F',
        ペ: '\uFF8D\uFF9F',
        ポ: '\uFF8E\uFF9F',
        ヴ: '\uFF73\uFF9E',
        ヷ: '\uFF9C\uFF9E',
        ヺ: '\uFF66\uFF9E',
        '\u3002': '\uFF61', // 。
        '\u3001': '\uFF64', // 、
        ー: '\uFF70',
        '\u300C': '\uFF62', // 「
        '\u300D': '\uFF63', // 」
        '\u30FB': '\uFF65', // ・
        '\u309B': '\uFF9E', // 「パ」の ○
        '\u309C': '\uFF9F' // 「バ」の "
      }
      const h2z = (str) => {
        const reg = new RegExp(
          '(' + Object.keys(henkanObj).join('|') + ')',
          'g'
        )
        return str.replace(reg, (match) => {
          return henkanObj[match]
        })
      }
      const z2h = (str) => {
        const k = inverseObject(henkanObj)
        const reg = new RegExp('(' + Object.keys(k).join('|') + ')', 'g')
        return str.replace(reg, (match) => {
          return k[match]
        })
      }
      return n ? h2z(str) : z2h(str)
    },

    /**
     * 引数の回数分文字列を繰り返す
     *
     * @param {*} str
     * @param {*} n
     * @returns
     */
    repeat(str, n) {
      if (!str || !n) return str
      return str.repeat(n)
    },

    /**
     * 文字列の両端の空白を削除
     *
     * @param {*} str
     * @returns
     */
    trim(str) {
      if (!str) return str
      return str.trim()
    },

    /**
     * 文字列をすべて置換
     *
     * @param {*} str
     * @param {*} a
     * @param {*} b
     * @returns
     */
    replace(str, a, b) {
      if (!str) return str
      const re = new RegExp(a, 'g')
      return str.replace(re, b)
    },

    /**
     * 日付に曜日を付ける
     *
     * @param {*} date
     * @param {*} suffix
     * @returns
     */
    youbi(date, suffix) {
      if (!date) return ''
      const [y, m, d] = date
        .replace(/[年月-]/g, '/')
        .replace('日', '')
        .split('/')
      const _m = +m - 1
      const _d = +d
      const day = '日月火水木金土'.charAt(new Date(y, _m, _d).getDay())
      if (suffix) {
        return `${date} ${day}${suffix}`
      } else {
        return `${date} (${day})`
      }
    },

    /**
     * 指定したキーの値を返す
     *
     * @param {*} users
     * @param {*} key
     * @returns
     */
    pluck(users, key) {
      if (!users || !key) return ''
      return users.map((user) => user[key])
    }
  }
})
